import { createSearchParamsContext } from 'src/app/shared/contexts/SearchParamsContext'

// Create Client User Setup search params context
const { Provider, useContext } = createSearchParamsContext(
  'bfa_client_user_setup_search_params',
  'ClientUserSetupFilters'
)

export const ClientUserSetupFiltersProvider = Provider
export const useClientUserSetupFilters = useContext
